var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":_vm.messageObj.show,"dismissible":"","variant":this.mapCodeToClass(_vm.messageObj.type)},on:{"dismissed":_vm.closeAlert}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.messageObj.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }